export default "__VITE_ASSET__DKeD$BGY__"